import { useQuery } from "@tanstack/react-query";
import { BillingService } from "../services/billingService";

const useBillSummary = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['billSummary'],
        queryFn: () => BillingService.getBillSummary(),
    });

    return { data, isLoading, error };
};

export default useBillSummary;
